<template>
  <div>
    <label v-if="label" class="text-sm form-label">{{ label }}:</label>
    <div class="p-0 form-input" :class="{ error: errors.length, 'bg-gray-200': disabled }">
      <input
        ref="file"
        type="file"
        :accept="accept"
        class="hidden"
        :disabled="disabled"
        @change="change">
      <div v-if="!value" class="p-2">
        <button
          type="button"
          :class="buttonStyles"
          @click="browse">
          <i v-if="disabled" class="fas fa-times-circle" />
          {{ mainButtonText }}
        </button>
      </div>
      <div v-else class="flex justify-between items-center p-2">
        <template v-if="typeof value === 'string'">
          <div class="flex-1 pr-1 font-semibold">
            (Data berkas tersedia...)
          </div>
          <button
            @click="preview"
            type="button"
            class="px-4 py-1 hover:bg-gray-600 bg-green-500 rounded-sm text-xs font-medium text-white">
            Preview
          </button>
        </template>
        <template v-else>
          <div class="flex-1 pr-1">
            {{ value.name }}
            <span class="text-xs text-gray-500">({{ filesize(value.size) }})</span>
          </div>
        </template>
        <button
          v-if="!disabled"
          type="button"
          class="ml-2"
          :class="buttonStyles"
          @click="remove">
          Remove
        </button>
      </div>
    </div>
    <div v-if="errorMessage.length" class="form-error">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: [File, String],
    label: String,
    accept: String,
    errors: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
  },
  computed: {
    errorMessage () {
      return this.$attrs.error ? this.$attrs.error : ''
    },
    buttonStyles () {
      return this.disabled
        ? 'px-4 py-1 bg-red-500 rounded-sm text-xs font-medium text-white'
        : 'px-4 py-1 bg-gray-500 hover:bg-gray-700 rounded-sm text-xs font-medium text-white'
    },
    mainButtonText () {
      return this.disabled ? 'Disabled' : 'Browse'
    },
  },
  watch: {
    value (value) {
      if (!value) this.$refs.file.value = ''
    },
  },
  methods: {
    filesize (size) {
      var i = Math.floor(Math.log(size) / Math.log(1024))
      return (
        (size / Math.pow(1024, i)).toFixed(2) * 1 +
        ' ' +
        ['B', 'kB', 'MB', 'GB', 'TB'][i]
      )
    },
    browse () {
      this.$refs.file.click()
    },
    change (e) {
      this.$emit('input', e.target.files[0])
    },
    remove () {
      this.$emit('input', null)
    },
    preview () {
      this.$emit('preview', this.value)
    },
  },
}
</script>
